import log from 'loglevel'
import axios from 'axios'
import Cache from '../../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Type {
  constructor() {
    log.info('[INFO] Initialize Type Module')
    this.cache = new Cache()
  }

  fetchAllTypes(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/order/assistance/type/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch all type')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch all type')
            log.error(error)
            reject(error.response)
          })
      })

      return promise
    })

    return result
  }

  fetchType(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/order/assistance/type/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch type')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch type')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateType(id, typeData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/order/assistance/type/${id}/`, typeData)
        .then(response => {
          log.debug('[DEBUG] Success to update type')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update type')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addType(typeData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/order/assistance/type/', typeData)
        .then(response => {
          log.debug('[DEBUG] Success to add type')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add type')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteType(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/order/assistance/type/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to delete type')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete type')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
